import type { ChapterComment } from "./models";

/** Edit comment body (signed-in book owner may only edit their own / unattributed comments). */
export function canEditDesktopChapterComment(
  comment: ChapterComment,
  currentUserId: string | null
): boolean {
  if (comment.createdBy === "ai") return false;
  if (!currentUserId) return comment.authorUserId == null;
  if (comment.authorUserId == null) return true;
  return comment.authorUserId === currentUserId;
}

/** Delete comment (same rules as edit). */
export function canDeleteDesktopChapterComment(
  comment: ChapterComment,
  currentUserId: string | null
): boolean {
  return canEditDesktopChapterComment(comment, currentUserId);
}

/** Resolve / reopen — signed-in authors may clear any reader comment on their manuscript. */
export function canResolveDesktopChapterComment(
  comment: ChapterComment,
  currentUserId: string | null
): boolean {
  if (comment.createdBy === "ai") return false;
  if (comment.type === "praise") return false;
  if (currentUserId) return true;
  if (comment.authorUserId == null) return true;
  return comment.authorUserId === currentUserId;
}

/** @deprecated Use canEditDesktopChapterComment / canDeleteDesktopChapterComment / canResolveDesktopChapterComment */
export function canModifyDesktopChapterComment(
  comment: ChapterComment,
  currentUserId: string | null
): boolean {
  return canEditDesktopChapterComment(comment, currentUserId);
}
